<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    :width="followtype ?'520px':'456px'"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="formHandle"
    @cancel="cancelHandler"
  >
    <div class="quit-dialog-box">
      <a-form
        ref="createForm"
        :form="form"
        :hide-required-mark="true"
        class="demo-form-inline"
      >
        <template v-if="!followtype">
          <a-form-item
            :label="`${quitTitTxt}：`"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 12 }"
            class="follow-quit-type"
          >
            <team-person-select
              :title="handoverPlace"
              :form="form"
              :is-show="isLimitDialogShow"
              @changeVal="getSelectVal"
            />
          </a-form-item>
        </template>
        <template v-else>
          <a-form-item>
            <a-radio-group
              v-decorator="['allotype',{initialValue: '1'}]"
              @change="changeType"
            >
              <a-radio value="1">
                {{ $t('message["1602"]') }}
              </a-radio>
              <a-radio value="2">
                {{ $t('message["997"]') }}
              </a-radio>
              <a-radio
                v-if="enableshare"
                value="3"
              >
                {{ $t('message["1007"]') }}
              </a-radio>
              <a-radio value="4">
                {{ $t('message["1621"]') }}
              </a-radio>
              <a-radio value="5">
                {{ $t('message["417"]') }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <template>
            <team-person-select
              v-if="isSelectShow"
              :title="title"
              :val="valarr"
              :type="type"
              :form="form"
              :is-show="isLimitDialogShow"
              @changeVal="getSelectVal"
            />
            <p
              v-else
              class="type-tip"
            >
              <template v-if="type===4">
                {{ $t('message["1167"]') }}
              </template>
              <template v-if="type===5">
                {{ $t('message["1166"]') }}
              </template>
            </p>
          </template>
        </template>
      </a-form>
      <allot-suc
        ref="allotSuc"
        :inquryid="inquryid"
      />
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import TeamPersonSelect from './TeamPersonSelect'
import AllotSuc from './AllotSuc'
export default {
  components: {
    TeamPersonSelect,
    AllotSuc
  },
  props: {
    inquryid: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      title: this.$t('message["882"]'),
      isSelectShow: true,
      teamPersonData: {},
      valarr: [],
      type: 1
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('quit', ['quitName']),
    queryArgs () {
      return this.$route.query
    },
    followtype () {
      const { scope = '' } = this.queryArgs
      return scope === 'follow'
    },
    isClue () {
      const { scope = '' } = this.queryArgs
      return scope === 'clue'
    },
    enableshare () {
      const { enableshare } = this.baseinfo || {}
      return enableshare
    },
    modalTit () {
      return this.$t('message["500"]')
    },
    quitTitTxt () {
      return this.$t('message["502"]')
    },
    handoverPlace () {
      return this.$t('message["868"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    }
  },
  watch: {
    async isLimitDialogShow (val) {
      if (val) {
        if (this.followtype) {
          const chain = await this.getTeamPersonList()
          chain.params({
            pk: 'inquiry-followup',
            type: 0,
            deal: 1
          })
            .fetch()
          this.form.setFieldsValue({ allotype: '1' })
        } else {
          const chain = await this.getTeamPersonList()
          chain.params({
            pk: this.isClue ? 'clue-followup' : `inquiry-${this.queryArgs.scope !== 'input' ? this.queryArgs.scope : 'add'}`,
            deal: 1
          })
            .fetch()
        }
      }
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('quit', ['getTeamPersonList', 'subQuitForm']),
    ...mapMutations('quit', ['setSelectList']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
      this.title = this.$t('message["882"]')
    },
    async changeType (e) {
      this.teamPersonData = {}
      let val = e.target.value * 1
      let type
      if (val === 1) {
        type = 0
        this.title = this.$t('message["882"]')
        this.isSelectShow = true
      } else if (val === 2) {
        type = 1
        this.title = this.$t('message["883"]')
        this.isSelectShow = true
      } else if (val === 3) {
        type = 1
        this.title = this.$t('message["884"]')
        this.isSelectShow = true
      } else if (val === 4 || val === 5) {
        this.isSelectShow = false
      }
      this.type = val
      if (val !== 4 || val !== 5) {
        this.setSelectList([])
        const chain = await this.getTeamPersonList()
        chain.params({
          pk: 'inquiry-followup',
          type,
          deal: 1
        })
          .fetch()
      }
    },
    formHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          let obj = {}
          if (this.followtype) {
            obj = Object.assign(this.teamPersonData, {
              inquiryid: this.inquryid,
              fromuserid: this.quitName.userid,
              type: values.allotype * 1 || '',
              scope: this.queryArgs.scope
            })
          } else {
            obj = Object.assign(this.teamPersonData, {
              [this.isClue ? 'ids' : 'inquiryid']: this.inquryid,
              fromuserid: this.quitName.userid,
              scope: this.queryArgs.scope
            })
          }
          this.confirmLoading = true
          const chain = await this.subQuitForm({ isClue: this.isClue })
          chain.params(obj)
            .onSuccess((raw) => {
              this.isLimitDialogShow = false
              this.$refs.allotSuc.changeVisible(true)
            })
            .onNetSuccess((res) => {
              this.confirmLoading = false
            })
            .fetch()
        }
      })
    },
    getSelectVal (obj) {
      let params = {}
      if (this.isClue) {
        if (obj.userid) {
          params['touserid'] = obj.userid
        }
        if (obj.roleid) {
          params['toroleid'] = obj.roleid
        }
        if (obj.groupid) {
          params['togroupid'] = obj.groupid
        }
      } else {
        params = obj
      }
      this.teamPersonData = params
    },
    cancelHandler () {
      this.isLimitDialogShow = false
      this.teamPersonData = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.quit-dialog-box::v-deep {
  .type-tip {
    color: #b3b3b3;
  }
  .ant-input {
    width: 470px;
  }
  .ant-cascader-picker-arrow {
    right: -140px;
  }
  .follow-quit-type {
    .ant-input{
      width: 320px !important;
    }
  }
}
</style>
